<template>
  <div>
    <LazyImage class="mobile-only intro-image" :url="require('../../assets/star.svg')"/>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import LazyImage from '@/components/LazyImage'

export default {
  name: 'otherContentFinal',

  props: {
    companyId: String,
    siteId: String
  },

  computed: {
    ...mapState(['currentUser']),

    firstName() {
      let name = this.currentUser.name || ''
      return name.split(' ')[0]
    }
  },

  components: {
    LazyImage
  },

  mounted() {
    let text = `I couldn't have done that any better myself. Good work, ${this.firstName}! Ready to preview your masterpeice?`

    this.$emit('setContinue', {
      name: 'sitePreview'
    }, text)
  }
}
</script>

<style lang="sass" scoped>
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/animations'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.intro-image, .video-wrapper
  max-width: 400px
  margin: $gap-large auto 0

  video
    width: 100%
</style>
